import React, { useState } from "react";
import { Modal, Button, Row, Col, Divider, Input, Form, DatePicker, Select, Switch } from "antd";
import {
  CheckOutlined,
  CloseCircleOutlined,
  EditOutlined,
  PlusOutlined,
  SaveOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import "./SelectBuyerForm.css";
import moment from "moment";
import { useLocation } from "react-router-dom";

export interface SelectBuyerFormProps {
  showForm: boolean;
  editBuyerData: any;
  postBuyer: (buyerInfo: any) => void;
  postBuyerSelected: (selectedBuyer: string, selectedDate: string) => void;
  buyers: any[];
  openNewBuyerForm: () => void;
  // loadedSale: any;
}

const SelectBuyerForm = (props: SelectBuyerFormProps) => {
  const [buyerInfo, setBuyerInfo] = useState({
    name: "",
    companyName: "",
    identificationCardNumber: "",
    contactNumber: "",
    emailAddress: "",
    address: "",
    companyCode: "",
    passportNumber: "",
  });
  const [nameFormStatus, setNameFormStatus] = useState("") as any;
  const [nameFormMessage, setNameFormMessage] = useState("");
  const [companyNameFormStatus, setCompanyNameFormStatus] = useState("") as any;
  const [companyNameFormMessage, setCompanyNameFormMessage] = useState("");
  const [identificationCardNumberFormStatus, setIdentificationCardNumberFormStatus] = useState("") as any;
  const [identificationCardNumberFormMessage, setIdentificationCardNumberFormMessage] = useState("");
  const [passportFormStatus, setPassportFormStatus] = useState("") as any;
  const [passportFormMessage, setPassportFormMessage] = useState("");
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  const [loadedSale, setLoadedSale] = useState({}) as any;
  const [selectedDate, setSelectedDate] = useState("");
  const [dateSelectedFormStatus, setDateSelectedFormStatus] = useState("") as any;
  const [dateSelectedFormMessage, setDateSelectedFormMessage] = useState("");
  const [selectedBuyer, setSelectedBuyer] = useState("");
  const [buyerSelectedFormStatus, setBuyerSelectedFormStatus] = useState("") as any;
  const [buyerSelectedFormMessage, setBuyerSelectedFormMessage] = useState("");
  const [isDateChanged, setIsDateChanged] = useState(false);
  const [buyerConfirmed, setBuyerConfirmed] = useState(false);
  // const [isSmallTransaction, setIsSmallTransaction] = useState(false);
  const [isNewBuyer, setIsNewBuyer] = useState(false);
  const location = useLocation();
  const updateName = (value: any) => {
    setNameFormStatus("");
    setNameFormMessage("");
    let buyer = { ...buyerInfo };
    buyer.name = value;
    setBuyerInfo(buyer);
  };

  const updateCompanyName = (value: any) => {
    setCompanyNameFormStatus("");
    setCompanyNameFormMessage("");
    let buyer = { ...buyerInfo };
    buyer.companyName = value;
    setBuyerInfo(buyer);
  };

  const updateIdentificationCardNumber = (value: any) => {
    setIdentificationCardNumberFormStatus("");
    setIdentificationCardNumberFormMessage("");
    let buyer = { ...buyerInfo };
    buyer.identificationCardNumber = value;
    setBuyerInfo(buyer);
  };

  const updatePassportNumber = (value: any) => {
    let buyer = { ...buyerInfo };
    buyer.passportNumber = value;
    setBuyerInfo(buyer);
  };

  const updateContactNumber = (value: any) => {
    let buyer = { ...buyerInfo };
    buyer.contactNumber = value;
    setBuyerInfo(buyer);
  };

  const updateEmailAddress = (value: any) => {
    let buyer = { ...buyerInfo };
    buyer.emailAddress = value;
    setBuyerInfo(buyer);
  };

  const updateAddress = (value: any) => {
    let buyer = { ...buyerInfo };
    buyer.address = value;
    setBuyerInfo(buyer);
  };

  const updateCompanyCode = (value: any) => {
    let buyer = { ...buyerInfo };
    buyer.companyCode = value;
    setBuyerInfo(buyer);
  };

  const validateForm = () => {
    let validationFormStatus = true;
    if (isDateChanged && selectedDate === "") {
      validationFormStatus = false;
      setDateSelectedFormStatus("error");
      setDateSelectedFormMessage("Select a date");
    }
    if (selectedBuyer === "") {
      validationFormStatus = false;
      setBuyerSelectedFormStatus("error");
      setBuyerSelectedFormMessage("Select a buyer");
    }
    return validationFormStatus;
  };

  const openCancelBuyerModal = () => {
    setIsCancelModalOpen(true);
  };

  const confirmCancelBuyer = () => {
    resetBuyerInfo();
    setIsCancelModalOpen(false);
    // closeForm();
  };

  const declineCancelBuyer = () => {
    setIsCancelModalOpen(false);
  };

  const resetBuyerInfo = () => {
    setBuyerInfo({
      name: "",
      companyName: "",
      identificationCardNumber: "",
      contactNumber: "",
      emailAddress: "",
      address: "",
      companyCode: "",
      passportNumber: "",
    });
    setNameFormStatus("");
    setNameFormMessage("");
    setCompanyNameFormStatus("");
    setCompanyNameFormMessage("");
    setIdentificationCardNumberFormStatus("");
    setIdentificationCardNumberFormMessage("");
  };

  const saveBuyerInfo = () => {};

  const addBuyerInfo = () => {
    props.postBuyer(buyerInfo);
    // closeForm();
  };

  const isNewSaleOrNotCompleted = () => {
    return location.pathname.split("/")[2] === undefined || !loadedSale.completed;
  };

  const updateSaleDate = (dateString: string) => {
    setDateSelectedFormStatus("");
    setDateSelectedFormMessage("");
    setSelectedDate(dateString);
  };

  const updateSetIsDateChanged = () => {
    setIsDateChanged(true);
  };

  const getUpdatedDate = () => {
    const dateProperties = selectedDate.split("/");
    return new Date(`${dateProperties[2]}-${dateProperties[1]}-${dateProperties[0]}`).toLocaleDateString("en-GB");
  };

  const confirmBuyer = () => {
    props.postBuyerSelected(selectedBuyer, selectedDate);
    setBuyerConfirmed(true);
    setIsDateChanged(false);
  };

  const formatBuyerDropdown = () => {
    if (props.buyers === undefined || props.buyers.length === 0) return [];
    return props.buyers.map((buyer: any) => {
      let label = `${buyer.name}`;
      if (buyer.companyName) {
        label += ` - ${buyer.companyName}`;
      }
      if (buyer.identificationCardNumber) {
        label += ` ( IC: ${buyer.identificationCardNumber.slice(0, 6)}-${buyer.identificationCardNumber.slice(
          6,
          8
        )}-${buyer.identificationCardNumber.slice(8, 12)} )`;
      }
      if (buyer.passportNumber) {
        label += ` ( Passport: ${buyer.passportNumber} )`;
      }
      return {
        label: label,
        value: buyer.buyerID,
      };
    });
  };

  // const toggleSmallTransactionFlag = (checked: boolean) => {
  //   setIsSmallTransaction(checked);
  // };

  return props.showForm ? (
    <Row justify="center">
      <div className="select-buyer-form">
        <Row>
          <Col span={12}>
            <Row justify="start">
              <h2>Buyer Information</h2>
            </Row>
          </Col>
          <Col span={12}>
            <Row justify="end">
              {isNewSaleOrNotCompleted() ? (
                isDateChanged ? (
                  <Form layout="vertical">
                    <Form.Item validateStatus={dateSelectedFormStatus} help={dateSelectedFormMessage}>
                      <DatePicker
                        allowClear={false}
                        onChange={(date, dateString) => updateSaleDate(dateString)}
                        format={"DD/MM/YYYY"}
                        showToday
                        disabledDate={(current) => {
                          let customDate = moment().add(1, "day").format("YYYY-MM-DD");
                          return current && current > moment(customDate, "YYYY-MM-DD");
                        }}
                      />
                    </Form.Item>
                  </Form>
                ) : (
                  <>
                    {loadedSale.createdTimestamp !== undefined ? (
                      <h2>{new Date(loadedSale.createdTimestamp).toLocaleDateString("en-GB")}</h2>
                    ) : selectedDate !== "" ? (
                      <h2>{getUpdatedDate()}</h2>
                    ) : (
                      <h2>{new Date().toLocaleDateString("en-GB")}</h2>
                    )}
                    <Button
                      type="default"
                      onClick={() => updateSetIsDateChanged()}
                      icon={<EditOutlined />}
                      style={{ marginLeft: "10px" }}
                      disabled={buyerConfirmed}
                    ></Button>
                  </>
                )
              ) : (
                <h2>{new Date(loadedSale.createdTimestamp).toLocaleDateString("en-GB")}</h2>
              )}
            </Row>
          </Col>
        </Row>
        <Row>
          <Divider style={{ margin: "12px 0" }} />
        </Row>
        <Row justify="end">
          <Button type="default" onClick={() => props.openNewBuyerForm()} icon={<UserAddOutlined />}>
            Add New Buyer
          </Button>
        </Row>
        <Form layout="vertical">
          <Form.Item
            label={<label className="material-form-label">Select a Buyer*</label>}
            validateStatus={buyerSelectedFormStatus}
            help={buyerSelectedFormMessage}
          >
            <Select
              showSearch
              placeholder="Select a buyer"
              onChange={(value: any) => {
                setBuyerSelectedFormStatus("");
                setBuyerSelectedFormMessage("");
                setSelectedBuyer(value);
              }}
              optionFilterProp="label"
              onSearch={() => {}}
              options={formatBuyerDropdown()}
              style={{ width: "100%" }}
            />
          </Form.Item>
          {/* <Form.Item label={<label className="material-form-label">Small Transaction</label>}>
            <Switch checked={isSmallTransaction} onChange={toggleSmallTransactionFlag} />
          </Form.Item> */}
        </Form>
        <Row justify="center" style={{ marginTop: "20px" }}>
          <Button type="primary" icon={<CheckOutlined />} onClick={() => validateForm() && confirmBuyer()}>
            Confirm Buyer
          </Button>
        </Row>
      </div>
      <div className="select-buyer-overlay"></div>
    </Row>
  ) : null;
};

export default SelectBuyerForm;
